module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_1-c4a3c4360b2ebca77ac2ac94d22735a4.png";